// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2PMHe","description":"PatientConsentPreview_description__1bNDN"};